<template>
  <v-container>
    <NewProjectForm v-if="$route.params.formName === 'newProjectForm'" />
    <ModifyProjectForm v-if="$route.params.formName === 'modifyProjectForm'" />
  </v-container>
</template>

<script>
import axios from "axios";
import NewProjectForm from "./NewProjectForm";
import ModifyProjectForm from "./ModifyProjectForm";
export default {
  components: {
    ModifyProjectForm,
    NewProjectForm
  },
  name: "ProjectForms",

  data() {
    return {
      project: ""
    };
  },
  methods: {
    setBreadcrumb() {
      let project = {
        text: this.project,
        exact: true,
        href: "/projects/" + this.$route.params.id,
        last: true
      };
      let form = {
        text: "section." + this.$route.params.formName,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.push(project);
        }
        this.$route.meta.breadCrumb.push(form);
      } else {
        this.$route.meta.breadCrumb.pop();
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.pop();
          this.$route.meta.breadCrumb.push(project);
        }
        this.$route.meta.breadCrumb.push(form);
      }
      this.$store.state.sectionTitle = "section." + this.$route.params.formName;
    },
    getProject() {
      if (
        this.$route.params.formName === "modifyProjectForm" &&
        this.$route.meta.update
      ) {
        const path =
          this.$store.state.endpoint + "/user/project/" + this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            if (
              response.data.title["gl"] !== "" &&
              response.data.title["gl"] !== undefined
            ) {
              this.project = response.data.title["gl"];
            } else if (
              response.data.title["es"] !== "" &&
              response.data.title["es"] !== undefined
            ) {
              this.project = response.data.title["es"];
            } else if (
              response.data.title["en"] !== "" &&
              response.data.title["en"] !== undefined
            ) {
              this.project = response.data.title["en"];
            }
          })
          .finally(() => {
            this.setBreadcrumb();
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.setBreadcrumb();
      }
    }
  },

  created() {
    this.getProject();
  },

  updated() {
    this.getProject();
  }
};
</script>

<style scoped></style>
